module.exports = __webpack_public_path__ + "static/media/solana-sonata.07509a74.png";